import styled from 'styled-components'

interface DateRangePickerStyledProps {
  block?: boolean
}

export const DateRangePickerStyled = styled.div<DateRangePickerStyledProps>`
  position: relative;
  display: ${(props) => (props.block ? 'block' : 'inline-block')};
`
